module.exports = __webpack_public_path__ + "static/media/roboto7.2735a3a6.woff2";